import type { DataTableSort } from '@/components/data-table/DataTable'

export type ViewGrain = 'inventory' | 'order'
// Mirrors ViewPresetKey / ViewPresetLabel in forge/views/domain.py, in its order.
export const VIEW_PRESET_KEYS = ['actual', 'platforms', 'ymarket_cheap', 'orders'] as const
export type ViewPresetKey = typeof VIEW_PRESET_KEYS[number]
export const VIEW_PRESET_LABEL_VALUES = ['Актуальное', 'Площадки', 'Маркет: ниже порога', 'Заказы'] as const
export type ViewPresetLabel = typeof VIEW_PRESET_LABEL_VALUES[number]
export const VIEW_PRESET_LABELS: Readonly<Record<ViewPresetKey, ViewPresetLabel>> = {
  actual: 'Актуальное',
  platforms: 'Площадки',
  ymarket_cheap: 'Маркет: ниже порога',
  orders: 'Заказы',
}
export const ACTION_KEYS = ['publish', 'reprice', 'ymarket_reconcile'] as const
export type ActionKey = typeof ACTION_KEYS[number]
export const VIEW_HEADER_BUTTONS = ['cardSettings', 'ymarketCollect'] as const
export type ViewHeaderButton = typeof VIEW_HEADER_BUTTONS[number]

export function isViewPresetKey(value: string | undefined): value is ViewPresetKey {
  return VIEW_PRESET_KEYS.some((key) => key === value)
}

// The retired «Цены Маркета» preset; its links and saved views land on «Площадки».
export const RETIRED_YMARKET_PRICES_VIEW = 'ymarket_prices'

export interface ViewPreset<
  Grain extends ViewGrain = ViewGrain,
  Column extends string = string,
  Filters = never,
> {
  key: ViewPresetKey
  label: ViewPresetLabel
  grain: Grain
  columns: readonly Column[]
  sort: DataTableSort<Column>
  filters: Filters
  actions: readonly ActionKey[]
  headerButtons?: readonly ViewHeaderButton[]
}

export interface ViewPresetOverride<Column extends string = string> {
  columns?: readonly Column[]
  sort?: DataTableSort<Column>
}

export function mergeViewPreset<
  Grain extends ViewGrain,
  Column extends string,
  Filters,
>(
  builtin: ViewPreset<Grain, Column, Filters>,
  override: ViewPresetOverride<Column> | null | undefined,
): ViewPreset<Grain, Column, Filters> {
  return {
    key: builtin.key,
    label: builtin.label,
    grain: builtin.grain,
    columns: override?.columns ?? builtin.columns,
    sort: override?.sort ?? builtin.sort,
    filters: builtin.filters,
    actions: builtin.actions,
    ...(builtin.headerButtons === undefined ? {} : { headerButtons: builtin.headerButtons }),
  }
}
